<template>
  <v-content class="grey lighten-4">
    <v-toolbar class="blue-grey lighten-4 elevation-2">
      <v-toolbar-title>Gastos</v-toolbar-title>
    </v-toolbar>

    <v-dialog @keydown.esc="fechar" persistent max-width="500px" v-model="dialogoDespesa">
      <v-btn
        title="Novo Rateio"
        color="#ff0d7b"
        dark
        slot="activator"
        class="mb-2"
        small
        absolute
        right
        fab
        style="top: 10px;"
        v-if="podeEditar"
        :disabled="idDaEmpresa == null"
      >
        <v-icon>add</v-icon>
      </v-btn>
      <v-toolbar>
        <span class="headline">Despesa</span>
      </v-toolbar>

      <v-card>
        <v-container grid-list-md>
          <v-form v-model="validacaoDespesa" ref="formDespesa">
            <v-layout wrap>
              <v-flex xs12>
                <c-seletor-data 
                  @pegarData="(dataInserida) => editandoItem.dataDaDespesa = dataInserida"
                  @validacaoFormulario=" (formularioValidado) => validacaoSeletorData = formularioValidado" 
                  :regras="regraDataDespesa"
                  dataMinima="2000-01-01"
                  dataMaxima="2099-12-31"
                  nomeDoCampo="Data de Despesa" 
                  :data="editandoItem.dataDaDespesa">
                </c-seletor-data>
              </v-flex>

              <v-flex xs12>
                <v-select
                  :items="itensTipoDeGasto"
                  v-model="editandoItem.tipoDeGasto"
                  :disabled="desabilitaProUsuario"
                  item-text="texto"
                  item-value="nome"
                  label="Tipo de gasto"
                ></v-select>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  label="Cliente"
                  v-model="editandoItem.cliente"
                  :rules="regraCliente"
                  validate-on-blur
                  :disabled="desabilitaProUsuario"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 v-if="editandoItem.tipoDeGasto == 'KILOMETRAGEM'">
                <v-select
                  :items="itensPartida"
                  item-value="nome"
                  item-text="nome"
                  label="Partida"
                  v-model="editandoItem.partida"
                  :disabled="desabilitaProUsuario"
                ></v-select>

                <v-text-field
                  type="number"
                  label="KM até Cliente"
                  :disabled="desabilitaProUsuario"
                  v-model="editandoItem.kmCliente"
                  append-icon="navigation"
                  validate-on-blur
                ></v-text-field>
                <v-text-field
                  type="number"
                  label="KM Residencial"
                  :disabled="desabilitaProUsuario || ativaCampoKmResidencial"
                  v-model="editandoItem.kmResidencial"
                  append-icon="home"
                  validate-on-blur
                ></v-text-field>
              </v-flex>

              <!-- Area do Rateio -->
              <v-flex xs12>
                <v-autocomplete
                  label="Selecione um Centro de Custo"
                  append-icon="business_center"
                  v-model="editandoItem.rateio.departamento"
                  :items="centrosDeCusto"
                  :loading="loadingCentrosDeCusto"
                  :rules="regraCentroDeCusto"
                  item-text="nome"
                  item-value="id"
                  return-object
                >
                  <template slot="no-data">
                    <div class="noDataSlot">Centro de Custo não encontrado.</div>
                  </template>
                </v-autocomplete>

                <v-autocomplete
                  label="Selecione a Conta Gerencial"
                  append-icon="business_center"
                  v-model="contaGerencialSelecionada"
                  :items="contasGerenciais"
                  item-text="nome"
                  item-value="id"
                  :rules="regraContaGerencial"
                  return-object
                  validate-on-blur
                  :loading="loadingContasGerenciais"
                >
                  <template slot="no-data">
                    <div class="noDataSlot">Conta gerencial não encontrada.</div>
                  </template>
                </v-autocomplete>
                <v-text-field
                  v-if="editandoItem.tipoDeGasto == 'KILOMETRAGEM'"
                  label="Valor"
                  v-model="calculaValorTotalDoItem"
                  append-icon="monetization_on"
                  validate-on-blur
                  readonly
                  :disabled="desabilitaProUsuario"
                ></v-text-field>
                <v-text-field
                  v-else
                  label="Valor"
                  v-model="editandoItem.rateio.valor"
                  @blur="formataValorRateio"
                  append-icon="monetization_on"
                  validate-on-blur
                  :disabled="desabilitaProUsuario"
                  :rules="regraValorDoRateio"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>

        <v-card-actions style="background-color: #fff">
          <v-spacer></v-spacer>
          <v-btn color="pink" flat @click.native="fechar">Cancelar</v-btn>
          <v-btn
            color="indigo darken-4"
            flat
            @click.native="salvar"
            :disabled="!passouNasRegrasDeValidacao || !validacaoSeletorData"
          >Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogConfirmar" max-width="500px">
      <v-card style="background-color: #cc0033;">
        <v-card-title primary-title>
          <p
            class="subTitulo"
            style="color: white; margin: auto; text-align: center;"
          >Tem certeza que deseja excluir este item?</p>
        </v-card-title>
        <v-card-actions>
          <v-btn color="white" style="margin: auto; text-align: center;" @click="deletar">Sim</v-btn>
          <v-btn
            color="white"
            style="margin: auto; text-align: center;"
            @click="dialogConfirmar = false"
          >Não</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-data-table :items="filtraDespesas" :headers="headers" hide-actions>
      <template slot="items" slot-scope="props">
        <tr v-if="podeEditar || $route.name != 'reembolso'">
          <td>{{ formataData(props.item.dataDaDespesa) }}</td>
          <td>{{ formataTipoGasto(props.item.tipoDeGasto) }}</td>
          <td>{{ props.item.cliente }}</td>
          <td>{{ props.item.rateio.contaGerencial.nome }}</td>
          <td>{{ props.item.rateio.departamento.nome }}</td>
          <td>{{ converteMoedaReal(props.item.rateio.valor, tipoDeMoeda) }}</td>
          <td class="justify-center layout px-0">
            <v-icon
              small
              class="mr-2"
              @click="editar(props.item)"
              :disabled="verificaSePodeEditar"
            >edit</v-icon>

            <v-icon small @click="abreDialogoDelete(props.item)" :disabled="!podeEditar">delete</v-icon>
          </td>
        </tr>
        <tr v-else>
          <td>{{ props.item.rateio.contaGerencial.nome }}</td>
          <td>{{ props.item.rateio.departamento.nome }}</td>
          <td>{{ converteMoedaReal(props.item.rateio.valor, tipoDeMoeda) }}</td>
        </tr>
      </template>

      <template slot="no-data">
        <p class="text-xs-center" style="margin: 0; padding: 0">Nenhuma despesa lançada.</p>
      </template>
    </v-data-table>
    <v-layout row wrap style="padding: 10px;">
      <v-flex md4 xs12 offset-md9>
        <span class="total">Total:</span>
        {{ converteMoedaReal(calculaValorTotal, tipoDeMoeda) }}
      </v-flex>
      <v-flex xs12>
        <div class="text-xs-center">
          <v-btn
            class="white--text"
            color="#005ca3"
            @click="dialogoDetalhesDespesa = true"
            v-if="!podeEditar"
          >Ver Detalhes</v-btn>
        </div>
      </v-flex>
    </v-layout>

    <!-- Para o aprovador conferir detalhes do rateio -->
    <v-dialog
      @keydown.esc="dialogoDetalhesDespesa = false"
      v-model="dialogoDetalhesDespesa"
      max-width="960"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Detalhes do Rateio</span>
        </v-card-title>

        <v-data-table
          hide-actions
          :headers="titulosTabelaDespesasSemEdicao"
          :items="despesasCadastradas"
        >
          <template slot="items" slot-scope="props">
            <td>{{ formataData(props.item.dataDaDespesa) }}</td>
            <td>{{ formataTipoGasto(props.item.tipoDeGasto) }}</td>
            <td>{{ props.item.cliente }}</td>
            <td>{{ props.item.rateio.departamento.nome }}</td>
            <td>{{ props.item.rateio.contaGerencial.nome }}</td>
            <td>{{ props.item.partida }}</td>
            <td>{{ props.item.kmCliente }}</td>
            <td>{{ props.item.kmResidencial }}</td>
            <td>{{ converteMoedaReal(props.item.rateio.valor, tipoDeMoeda) }}</td>
            <td class="justify-center layout px-0">
              <v-icon
                small
                class="mr-2"
                @click="editar(props.item)"
                :disabled="verificaSePodeEditar"
              >edit</v-icon>

              <v-icon small @click="abreDialogoDelete(props.item)" :disabled="!podeEditar">delete</v-icon>
            </td>
          </template>
        </v-data-table>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="dialogoDetalhesDespesa = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-content>
</template>

<script>
import axios from "axios";
import unionBy from "lodash";
import { novaData } from "../../mixins/dateMixin.js";
import conversor from "../../mixins/moedasMixin.js";
import SeletorData from "../shared/SeletorData";

export default {
  name: "Despesas",
  props: {
    despesasCadastradas: {
      type: Array,
      default: []
    },
    podeEditar: {
      type: Boolean,
      default: true
    },
    ehAprovador: {
      type: Boolean,
      default: false
    },
    tipoDeMoeda: {
      type: String,
      default: "BRL"
    },
    idDaEmpresa: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dialogoDetalhesDespesa: false,
      itemAhSerRemovido: "",
      dialogConfirmar: false,
      dialogoDespesa: false,
      validacaoDespesa: false,
      modalDataDaDespesa: false,
      contaGerencialSelecionada: "",
      centrosDeCusto: [],
      loadingCentrosDeCusto: false,
      indexDoItemEditado: -1,
      editandoItem: {
        dataDaDespesa: null,
        tipoDeGasto: "",
        cliente: "",
        partida: "",
        kmCliente: "0",
        kmResidencial: "0",
        rateio: {
          departamento: {
            nome: "",
            id: ""
          },
          contaGerencial: {
            nome: "",
            id: ""
          },
          valor: ""
        }
      },
      modeloItem: {
        dataDaDespesa: null,
        tipoDeGasto: "",
        cliente: "",
        partida: "",
        kmCliente: "0",
        kmResidencial: "0",
        rateio: {
          departamento: {
            nome: "",
            id: ""
          },
          contaGerencial: {
            nome: "",
            id: ""
          },
          valor: ""
        }
      },
      loadingContasGerenciais: false,
      headers: [
        { text: "Data", value: "data", sortable: false },
        { text: "Tipo de Gasto", value: "Nome", sortable: false },
        { text: "Cliente", value: "cliente", sortable: false },
        { text: "Conta Gerencial", value: "Nome", sortable: false },
        { text: "Centro de Custo", value: "Nome", sortable: false },
        { text: "Total", value: "Nome", sortable: false },
        { text: "Ações", value: "Nome", sortable: false }
      ],
      titulosTabelaDespesasSemEdicao: [
        { text: "Data", value: "data", sortable: false },
        { text: "Tipo de Gasto", value: "Nome", sortable: false },
        { text: "Cliente", value: "cliente", sortable: false },
        { text: "Conta Gerencial", value: "Nome", sortable: false },
        { text: "Centro de Custo", value: "Nome", sortable: false },
        { text: "Partida", value: "Nome", sortable: false },
        { text: "KM Cliente", value: "Nome", sortable: false },
        { text: "KM Residencial", value: "Nome", sortable: false },
        { text: "Total", value: "Nome", sortable: false },
        { text: "Ações", value: "Nome", sortable: false }
      ],
      itensTipoDeGasto: [
        { nome: "KILOMETRAGEM", texto: "Kilometragem" },
        { nome: "PEDAGIO", texto: "Pedágio" },
        { nome: "ESTACIONAMENTO", texto: "Estacionamento" },
        { nome: "REFEICOES", texto: "Refeições" },
        { nome: "TAXI", texto: "Taxi" },
        { nome: "OUTRAS_DESPESAS", texto: "Outras Despesas" }
      ],
      itensPartida: [{ nome: "Casa" }, { nome: "Empresa" }],
      regraDataDespesa: [
        data => {
          if(data == "Invalid date") return "Data da despesa é obrigatória"
          else return data.length >= 8 || "Digite uma data válida."
        }
      ],
      regraCliente: [
        cliente => !!cliente || "Identificação do cliente é obrigatório."
      ],
      regraContaGerencial: [
        contaGerencial => !!contaGerencial || "Conta Gerencial é obrigatória.",
        centroCusto =>
          this.filtraDespesas.filter(item => {
            if (this.$route.name != "reembolso") {
              if (this.indexDoItemEditado == -1) {
                if (
                  item.rateio.departamento.id ===
                    this.editandoItem.rateio.departamento.id &&
                  item.rateio.contaGerencial.id ==
                    this.contaGerencialSelecionada.id
                )
                  return true;
                else return false;
              } else {
                for (let i = 0; i < this.filtraDespesas.length; i++) {
                  if (i != this.editedCenterIndex) {
                    if (
                      this.filtraDespesas[i].rateio.departamento.id ===
                        this.editandoItem.rateio.departamento.id &&
                      this.filtraDespesas[i].rateio.contaGerencial.id ==
                        this.contaGerencialSelecionada.id
                    ) {
                      return true;
                    } else return false;
                  }
                }
              }
            }
          }) == false || "Centro de custo com conta gerencial já cadastrado."
      ],
      regraCentroDeCusto: [
        centroCusto => !!centroCusto || "Centro de Custo é obrigatório."
      ],
      regraValorDoRateio: [
        valor => !!valor || "Valor do rateio é obrigatório.",
        value => {
          if (
            Number(
              conversor.methods.converterValorStringEmNumero(
                value,
                this.tipoDeMoeda
              )
            ) <= 0
          )
            return `O valor do rateio não pode ser zerado.`;
        }
      ],
      contasGerenciais: [],
      validacaoSeletorData: false,
    };
  },
  computed: {
    passouNasRegrasDeValidacao() {
      if (this.validacaoDespesa) return true;
      else return false;
    },
    centroDeCusto() {
      return this.editandoItem.rateio.departamento;
    },
    loggedUser() {
      return this.$store.getters.loggedUser;
    },
    ativaCampoKmResidencial() {
      let desativar = false;
      if (this.editandoItem.partida === "Empresa") {
        this.editandoItem.kmResidencial = 0;
        desativar = true;
      }

      return desativar;
    },
    calculaValorTotalDoItem() {
      const kmCliente = parseFloat(this.editandoItem.kmCliente);
      const kmResidencial = parseFloat(this.editandoItem.kmResidencial);

      let total = this.calculaValorDoReembolso(kmCliente, kmResidencial);
      this.editandoItem.rateio.valor = conversor.methods.converterParaMoedaReal(
        total,
        this.tipoDeMoeda
      );
      return this.editandoItem.rateio.valor;
    },
    todasAsContasGerenciais() {
      return this.$store.getters.todasAsContasGerenciais;
    },
    usuarioAutenticado() {
      return this.$store.getters.usuarioAutenticado;
    },
    calculaValorTotal() {
      let total = 0;

      this.despesasCadastradas.map(item => {
        total += parseFloat(item.rateio.valor);
      });

      this.$store.commit("set", {
        itemName: "totalDespesas",
        content: total
      });

      this.$emit("passaValorTotal", total);
      return total;
    },
    filtraDespesas() {
      let arrayParaSomar = [];
      let ehReembolso = this.$route.name == "reembolso";
      if (!this.podeEditar && ehReembolso) {
        this.despesasCadastradas.map(i => {
          if (i.mesclado != true) {
            let itensEncontradosIguais = [];

            this.despesasCadastradas.map(d => {
              const { rateio } = d;
              if (
                i.rateio.contaGerencial.id === rateio.contaGerencial.id &&
                i.rateio.departamento.id === rateio.departamento.id
              ) {
                d.mesclado = true;
                itensEncontradosIguais.push(d);
              }
            });

            if (itensEncontradosIguais.length > 1) {
              let soma = 0;
              itensEncontradosIguais.map(s => (soma += s.rateio.valor));

              const nomeDepartamento = i.rateio.departamento.nome;
              const nomeContaGerencial = i.rateio.contaGerencial.nome;

              let itemPraInserir = {
                rateio: {
                  departamento: {},
                  contaGerencial: {}
                }
              };

              Object.defineProperties(itemPraInserir.rateio.departamento, {
                nome: {
                  value: nomeDepartamento,
                  configurable: true,
                  writable: true,
                  enumerable: true
                }
              });

              Object.defineProperties(itemPraInserir.rateio.contaGerencial, {
                nome: {
                  value: nomeContaGerencial,
                  configurable: true,
                  writable: true,
                  enumerable: true
                }
              });

              Object.defineProperties(itemPraInserir.rateio, {
                valor: {
                  value: soma,
                  configurable: true,
                  writable: true,
                  enumerable: true
                }
              });
              arrayParaSomar.push(itemPraInserir);
            } else {
              arrayParaSomar.push(i);
            }
          }
        });
      } else {
        arrayParaSomar = [...this.despesasCadastradas];
        if (!ehReembolso && !this.podeEditar) {
          return [arrayParaSomar[0]];
        }
      }
      return arrayParaSomar;
    },
    verificaSePodeEditar() {
      let autorizaEdicao;
      this.usuarioAutenticado.papeis.filter(perfil => {
        if (perfil.nome.indexOf("APROVADOR_CONTABILIDADE") == -1) {
          autorizaEdicao = !this.podeEditar;
        } else {
          autorizaEdicao = false;
        }
      });
      return autorizaEdicao;
    },
    desabilitaProUsuario() {
      let autorizaEdicao;
      this.usuarioAutenticado.papeis.filter(perfil => {
        if (
          perfil.nome.indexOf("APROVADOR_CONTABILIDADE") == -1 &&
          perfil.nome.indexOf("SOLICITANTE") != -1
        ) {
          autorizaEdicao = !this.podeEditar;
        } else if (
          perfil.nome.indexOf("APROVADOR_CONTABILIDADE") >= -1 &&
          perfil.nome.indexOf("SOLICITANTE") >= -1
        ) {
          autorizaEdicao = !this.podeEditar;
        } else {
          autorizaEdicao = true;
        }
      });
      return autorizaEdicao;
    }
  },
  methods: {
    verificarData(v) {
      let anoDoDiaDeHoje = novaData("Ano");
      let anoDoDiaRecebido = novaData("Ano", v);
      if (anoDoDiaRecebido < 2000 || anoDoDiaRecebido > 2099) {
        return "Ano Inválido.";
      }
      return true;
    },
    converteMoedaReal(valor, tipoDeMoeda) {
      return conversor.methods.converterParaMoedaReal(valor, tipoDeMoeda);
    },

    formataData(data) {
      let [ano, mes, dia] = data.split("T")[0].split("-");
      return `${dia}/${mes}/${ano}`;
    },
    formataTipoGasto(stringNome) {
      if (stringNome == null || stringNome == "") return;

      return stringNome.replace(/_/g, " ");
    },
    converteValorStringEmNumero(valor) {
      if (typeof valor != "string") return valor;

      valor = valor
        .replace("R$", "")
        .replace("$", "")
        .replace("￥", "")
        .replace("€", "")
        .replace("£", "")
        .replace("S$", "")
        .replace("Mex$", "");
      if (this.tipoDeMoeda.indexOf("BRL") != -1) {
        valor = valor.replace(/\./g, "");
        valor = valor.replace(",", ".");
      } else if (this.tipoDeMoeda.indexOf("EUR") != -1) {
        valor = valor.replace(/\s/g, "");
        valor = valor.replace(",", ".");
      } else {
        valor = valor.replace(/\,/g, "");
      }

      if (isNaN(valor)) {
        valor = 0;
        return valor;
      }

      return valor;
    },
    converteParaMoedaReal(numero) {
      let formatter;
      if (this.tipoDeMoeda == "USD")
        formatter = this.converterOutrasMoedas("en-US", "currency", "USD");
      else if (this.tipoDeMoeda == "AUD")
        formatter = this.converterOutrasMoedas("en-au", "currency", "AUD");
      else if (this.tipoDeMoeda == "CAD")
        formatter = this.converterOutrasMoedas("en-ca", "currency", "CAD");
      else if (this.tipoDeMoeda == "JPY")
        formatter = this.converterOutrasMoedas("ja", "currency", "JPY");
      else if (this.tipoDeMoeda == "EUR")
        formatter = this.converterOutrasMoedas("fr", "currency", "EUR");
      else if (this.tipoDeMoeda == "GBP")
        formatter = this.converterOutrasMoedas("en-gb", "currency", "GBP");
      else if (this.tipoDeMoeda == "SGD")
        formatter = this.converterOutrasMoedas("zh-sg", "currency", "SGD");
      else if (this.tipoDeMoeda == "MXN")
        formatter = this.converterOutrasMoedas("es-mx", "currency", "MXN");
      else formatter = this.converterOutrasMoedas("pt-BR", "currency", "BRL");
      return formatter.format(numero);
    },

    converterOutrasMoedas(linguagem, estilo, pais) {
      return new Intl.NumberFormat(linguagem, {
        style: estilo,
        currency: pais,
        minimumFractionDigits: 2
      });
    },
    formataValorRateio(eventoBlur) {
      const formataValor = conversor.methods.converterValorStringEmNumero(
        eventoBlur.target.value,
        this.tipoDeMoeda
      );
      this.editandoItem.rateio.valor = conversor.methods.converterParaMoedaReal(
        formataValor,
        this.tipoDeMoeda
      );
    },
    async inicializa() {
      await this.$store.dispatch("get", {
        loaderName: "loadingManagementAccounts",
        service: "/contasgerenciais?size=50000",
        itemName: "todasAsContasGerenciais"
      });
    },
    calculaValorDoReembolso(kmCliente, kmResidencial) {
      let total = 0;
      if (kmCliente > kmResidencial) total = (kmCliente - kmResidencial) * 0.7;

      return total;
    },
    fechar() {
      this.dialogoDespesa = false;
      this.loadingCentrosDeCusto = false;
      this.contaGerencialSelecionada = "";
      this.indexDoItemEditado = -1;
      this.editandoItem = Object.assign({}, this.modeloItem);
      this.editandoItem.rateio = Object.assign({
        departamento: {
          nome: "",
          id: ""
        },
        contaGerencial: {
          nome: "",
          id: ""
        },
        valor: ""
      });
    },
    salvar() {
      if (this.$refs.formDespesa.validate()) {
        let numero = this.converteValorStringEmNumero(
          this.editandoItem.rateio.valor
        );
        this.editandoItem.rateio.valor = parseFloat(numero);
        this.editandoItem.rateio.contaGerencial = this.contaGerencialSelecionada;

        let copia = Object.assign({}, this.editandoItem);
        if (this.indexDoItemEditado > -1) {
          Object.assign(
            this.despesasCadastradas[this.indexDoItemEditado],
            copia
          );
        } else {
          this.despesasCadastradas.push(copia);
        }

        this.$emit("gastos", this.despesasCadastradas);
        this.fechar();
      }
    },
    editar(item) {
      this.indexDoItemEditado = this.despesasCadastradas.indexOf(item);
      this.contaGerencialSelecionada = item.rateio.contaGerencial;

      let [ano, mes, dia] = item.dataDaDespesa.split("T")[0].split("-");
      item.dataDaDespesa = `${ano}-${mes}-${dia}`;

      // preciso copiar o  objeto para quebrar a referência com objeto passado
      let itemCopia = Object.assign({
        dataDaDespesa: item.dataDaDespesa,
        tipoDeGasto: item.tipoDeGasto,
        cliente: item.cliente,
        partida: item.partida,
        kmCliente: item.kmCliente,
        kmResidencial: item.kmResidencial,
        rateio: {
          departamento: {
            nome: item.rateio.departamento.nome,
            id: item.rateio.departamento.id
          },
          contaGerencial: {
            nome: item.rateio.contaGerencial.nome,
            id: item.rateio.contaGerencial.id
          },
          valor: conversor.methods.converterParaMoedaReal(
            item.rateio.valor,
            this.tipoDeMoeda
          )
        }
      });

      Object.assign(this.editandoItem, itemCopia);
      this.dialogoDespesa = true;
    },
    abreDialogoDelete(item) {
      this.itemAhSerRemovido = item;
      this.dialogConfirmar = true;
    },
    deletar() {
      const index = this.despesasCadastradas.indexOf(this.itemAhSerRemovido);
      this.despesasCadastradas.splice(index, 1);
      this.dialogConfirmar = false;
    },
    formataNome(nomeItem) {
      if (nomeItem == null) return "Sem Valor";
      else return nomeItem;
    },
    async fazerRequest(url) {
      return await axios({
        method: "get",
        url: url,
        responseType: "json",
        headers: {
          Authorization: `Bearer ${this.usuarioAutenticado.token}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
        .then(resposta => {
          return resposta.data;
        })
        .catch(erro => {});
    }
  },
  watch: {
    async centroDeCusto(conta) {
      if (conta.id == "") return;
      this.loadingContasGerenciais = true;
      await this.fazerRequest(`/contasgerenciais/centrodecustos/${conta.id}`)
        .then(s => {
          this.contasGerenciais = s;
        })
        .catch(s => (this.centrosDeCusto = []))
        .finally(s => (this.loadingContasGerenciais = false));
    },
    async idDaEmpresa(val) {
      if (val == 0) return;
      this.contasGerenciais = [];
      this.loadingCentrosDeCusto = true;
      await this.fazerRequest(`/centrosdecustos/empresas/${val}`)
        .then(s => {
          this.centrosDeCusto = s;
        })
        .catch(s => (this.contasGerenciais = []))
        .finally(s => (this.loadingCentrosDeCusto = false));
    },
    podeEditar(val) {
      if (!val && this.$route.name == "reembolso") {
        this.headers = [
          { text: "Conta Gerencial", value: "Nome", sortable: false },
          { text: "Centro de Custo", value: "Nome", sortable: false },
          { text: "Total", value: "Nome", sortable: false }
        ];
      } else {
        this.headers = [
          { text: "Data", value: "data", sortable: false },
          { text: "Tipo de Gasto", value: "Nome", sortable: false },
          { text: "Cliente", value: "cliente", sortable: false },
          { text: "Conta Gerencial", value: "Nome", sortable: false },
          { text: "Centro de Custo", value: "Nome", sortable: false },
          { text: "Total", value: "Nome", sortable: false },
          { text: "Ações", value: "Nome", sortable: false }
        ];
      }
    }
  },
  async created() {
    await this.inicializa();
  },
  components: {
    "c-seletor-data": SeletorData
  }
};
</script>
<style scoped>
.total {
  color: #005ca3;
  font-weight: bold;
}
.noDataSlot {
  font-size: 1em;
  padding: 10px;
}
</style>